import { render, staticRenderFns } from "./ConsumablesManagement.vue?vue&type=template&id=06a70bba"
import script from "./ConsumablesManagement.vue?vue&type=script&lang=js"
export * from "./ConsumablesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports